import { render, staticRenderFns } from "./consumeRisk.vue?vue&type=template&id=1655aa30&"
import script from "./consumeRisk.vue?vue&type=script&lang=js&"
export * from "./consumeRisk.vue?vue&type=script&lang=js&"
import style0 from "./consumeRisk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1655aa30')) {
      api.createRecord('1655aa30', component.options)
    } else {
      api.reload('1655aa30', component.options)
    }
    module.hot.accept("./consumeRisk.vue?vue&type=template&id=1655aa30&", function () {
      api.rerender('1655aa30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/financialReport/consumeRisk.vue"
export default component.exports